import ContentLoader from "react-content-loader";
import { useSelector } from 'react-redux';
import Currency from '../../../../components/currency/currency';
import CurrencyFormat from '../../../../components/currencyFormat/currencyFormat';

export default function PersonalAccountDetails() {
    const { user } = useSelector((state) => state.auth);
    const { isUserDashboardLoading } = useSelector((state) => state.userDashboard);
    const { totalCashBalance } = useSelector(state => state.userDashboard);

    return (
        <>
            <div>
                <div className='accountBorderSection'>



                    <div className='container-fluid p-0'>
                        <div className="content-row-padding">

                            <div className='row'>
                                <div className='col-md-3 col-6'>
                                    <h6 className='accountPrimaryText'>Personal account number</h6>
                                    {isUserDashboardLoading ? (
                                        <div>
                                            <ContentLoader width="100%" height={15}>
                                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                            </ContentLoader>
                                        </div>
                                    ) : (
                                        <div className='accountSecondaryText'>{user?.personalAccountNumber || 'XXXXXXXX-XXXXXX'}</div>
                                    )}
                                </div>

                                <div className='col-md-3 col-6 rightAlignText'>
                                    <h6 className='accountPrimaryText'>Total account balance</h6>
                                    {isUserDashboardLoading ? (
                                        <div>
                                            <ContentLoader width="100%" height={15}>
                                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                            </ContentLoader>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className='accountSecondaryText'>
                                                <Currency
                                                    currency={totalCashBalance?.currency}
                                                />
                                                <CurrencyFormat
                                                    currency={totalCashBalance?.currency}
                                                    value={parseFloat(totalCashBalance?.total)}
                                                    decimal={2}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
